import { BehaviorSubject } from 'rxjs';
import { RaiseSupportComponent } from './../../components/raise-support/raise-support.component';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { GetSupportRequestService } from '../../services/get-support-request.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-support-center',
  templateUrl: './support-center.component.html',
  styleUrls: ['./support-center.component.scss']
})
export class SupportCenterComponent implements OnInit {
  filterForm = this.fb.group({
    status: ['OPEN', [Validators.required]],
    search: [null, [Validators.required]],
    limit:[10],
    offset: [0]
  })
  filterSubject = new BehaviorSubject(this.filterForm.value);
  totalElements = 0;
  supportRequestListing: any[];
  selectedSupportRequest: any;
  constructor(
    private fb: FormBuilder,
    private _dialog: MatDialog,
    private getSupportRequestService: GetSupportRequestService
  ) { }

  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filterData=>{
      this.supportRequestListing = null;
      return this.getSupportRequestService.getSupportRequests(filterData);
    })).subscribe(([support_requests, count]: any)=>{
      console.log(support_requests, count);
      this.selectedSupportRequest = support_requests[0];
      this.supportRequestListing = support_requests;
      this.totalElements = count;
    })
  }

  raiseSupport() {
    const dialogRef = this._dialog.open(RaiseSupportComponent, {
      width: '35%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'], 
      disableClose: true,
      data: { type: "GENERAL" }
    });
    dialogRef.afterClosed().subscribe(data=>{
      if(data === 'yes'){
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  selectRequest(selectRequest: any){
    this.selectedSupportRequest = selectRequest;
  }
  /* --------------------------------- Getters -------------------------------- */
  get status(): FormControl {
    return this.filterForm.get('status') as FormControl;
  }
  get search(): FormControl {
    return this.filterForm.get('search') as FormControl;
  }
  get limit(){
    return this.filterForm.get('limit');
  }
  get offset(){
    return this.filterForm.get('offset');
  }
  setSearch(){
    this.filterSubject.next(this.filterForm.value);
  }
  setStatus(){
    this.filterSubject.next(this.filterForm.value);
  }
}
